import {
  GET_FIELD_OPTIONS,
  GET_FIELD_OPTIONS_SUCCESS,
  GET_FIELD_OPTIONS_FAIL,
  DELETE_PRODUCT_FIELD,
  DELETE_PRODUCT_FIELD_SUCCESS,
} from 'store/field-options/types';

export interface IFieldOptionForInitialState {
  error?: null;
  loading: boolean;
  products?: null;
  productLines?: null;
  regions?: null;
  statuses?: null;
  nonstandardRisks?: null;
  defaultTransportModes?: null;
  defaultIncoTerms?: null;
}

const initialState: IFieldOptionForInitialState = {
  error: null,
  loading: false,
  products: null,
  productLines: null,
  regions: null,
  statuses: null,
  nonstandardRisks: null,
  defaultIncoTerms: null,
  defaultTransportModes: null,
};

export interface IActionInterface {
  type: string;
  error: null;
  products?: null;
  productLines?: null;
  regions?: null;
  statuses?: null;
  nonstandardRisks?: null;
  transportModes?: null;
  incoTerms?: null;
}

function reducer(state = initialState, action: IActionInterface) {
  switch (action.type) {
    case GET_FIELD_OPTIONS: {
      return {
        ...state,
        loading: true,
      };
    }

    case DELETE_PRODUCT_FIELD: {
      return {
        ...state,
        error: null,
        loading: true,
      };
    }

    case GET_FIELD_OPTIONS_SUCCESS:
    case DELETE_PRODUCT_FIELD_SUCCESS: {
      const { products, productLines, regions, statuses, nonstandardRisks, transportModes, incoTerms } = action;
      return {
        ...state,
        loading: false,
        products,
        productLines,
        regions,
        statuses,
        nonstandardRisks,
        defaultTransportModes: transportModes,
        defaultIncoTerms: incoTerms,
      };
    }

    case GET_FIELD_OPTIONS_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
}

export default reducer;
